import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import Popup from 'reactjs-popup'
import PdfReader from 'components/pdfReader/pdfReader'
import { QRCodeSVG } from 'qrcode.react'
import "./inscriptionFormation.scss"
import ClosePopupBtn from 'components/buttons/closePopupBtn'
export default function InscriptionFormation(props) {
    const {setCounter, counterDefault} = props
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Comment m'inscrire à une formation",
            icon : "picto inscription - v2.svg",
            color : "bckDarkBlue"
        })
    }, [])
    return (
        <div id="inscriptionFormation"  className='page'>
            <img src="/inscription_formation.png" alt="" />
            <Popup 
                    trigger={
                        <div style={{position : "absolute", top :"1130px", left :"100px", width : "400px", height : "200px"}}></div>
                    }
                    modal
                    closeOnDocumentClick
                >
                    {
                        close => (
                            <div id="pdfReader">
                                <img src="/pdf/Formulaire_formation.jpg" onLoad={() => setCounter(counterDefault)} alt="" />
                                <ClosePopupBtn close={close}/>
                            </div>
                        )
                    }
            </Popup>
            <QRCodeSVG value="https://chu-rouen-drhf.spin-io.fr/pdf/Formulaire_formation.pdf" fgColor='#215fa5' bgColor='none' className='qrcode' size={150} />
        </div>
    )
}
